// react
import React, { useEffect, useContext } from 'react';
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';

// material-ui components
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from '@material-ui/core/TextField';
import LoadingIcon from "@material-ui/icons/Cached";

// material-ui icons
import { makeStyles } from "@material-ui/core/styles";

// core components
import Button from "beaktShared/components/CustomButtons/Button.js";
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import MenuItem from "@material-ui/core/MenuItem";
import { ValidSelect } from "beaktShared/helpers/validselect";
import Select from 'react-select';
import InputAdornment from '@material-ui/core/InputAdornment';
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";

// services
import { SessionContext } from "beaktShared/services/session";
import { UseGetApiSimple, UsePostApi, UsePutApi } from "beaktShared/services/crudeApiService";
import { getAvaliacaoCookie, setAvaliacaoCookie } from 'beaktClinic/services/avaliacaoCookie.js';

// style
import { MaskCPF, MaskCel } from "beaktShared/helpers/masks";
import styles from "assets/jss/BeaktClinic/views/Avaliacao/dadosCliente.js";

const useStyles = makeStyles(styles);

export default function DadosCliente({ nextButtonClick, classes_wizard }) {
  const { t } = useTranslation();

  const { register, handleSubmit, setValue, errors, clearError, setError } = useForm({ mode: "onBlur" });

  const [cpf, setCpf] = React.useState("");
  const [clienteId, setclienteId] = React.useState(0);
  const [sexo, setSexo] = React.useState("");
  const [clienteExiste, setClienteExiste] = React.useState(false);

  const [disabledNome, setdisabledNome] = React.useState(false);
  const [disabledCPF, setdisabledCPF] = React.useState(false);
  const [disabledEMAIL, setdisabledEMAIL] = React.useState(false);

  const [canalMidia, setcanalMidia] = React.useState("");
  const [loadingSelectCanalMidia, setloadingSelectCanalMidia] = React.useState(false);
  const [listSelectCanalMidia, setlistSelectCanalMidia] = React.useState([]);

  const [loadingValidateCPF, setloadingValidateCPF] = React.useState(false);
  const [loadingValidateEmail, setloadingValidateEmail] = React.useState(false);

  const classes = useStyles();
  const session = useContext(SessionContext);

  const [notification, setNotification] = React.useState(false);
  const [colorNotification, setColorNotification] = React.useState('info');
  const [mensagemNotification, setMensagemNotification] = React.useState(false);

  const showNotification = (mensagem, color) => {
    setMensagemNotification(mensagem);
    setColorNotification(color);
    setNotification(true);
    setTimeout(function () {
      setNotification(false);
    }, 6000);
  };

  const LoadingSelectCanalMidia = () => {
    setloadingSelectCanalMidia(true);
    const endPoint = "midia/byestabelecimento/" + session.estabelecimentoId;
    UseGetApiSimple(endPoint, 0).then(result => {
      if (result.status !== 200) {
        setloadingSelectCanalMidia(false);
        return false;
      }
      setlistSelectCanalMidia(result.data);
      setloadingSelectCanalMidia(false);
      return true;
    });
  }

  const loadingDados = () => {
    let avaliacao = getAvaliacaoCookie();

    if (!avaliacao)
      return;
    if (!avaliacao.cliente)
      return;

    setValue('cpf', avaliacao.cliente.cpf);
    setValue('nome', avaliacao.cliente.nome);
    setValue('email', avaliacao.cliente.email);
    setValue('celular', avaliacao.cliente.celular);
    if (avaliacao.cliente.sexo !== null) {
      setSexo(avaliacao.cliente.sexo);
      setValue("sexo", avaliacao.cliente.sexo);
      session.clienteSexo = avaliacao.cliente.sexo;
    }
    setValue('atendente', avaliacao.cliente.cpf);

    if (avaliacao.cliente.cpf != "") {
      const endPoint = "clientes/clientebycpf/" + avaliacao.cliente.cpf;
      UseGetApiSimple(endPoint, 0).then(result => {
        if (result.status === 200) {
          setClienteExiste(true);
          setdisabledNome(true);
          setdisabledCPF(true);
          setdisabledEMAIL(true);

        }
      });
    }
  }

  const reinicializarClick = () => {
    setAvaliacaoCookie(null);
    setValue('cpf', '');
    setValue('nome', '');
    setValue('email', '');
    setValue('celular', '');
    setValue('atendente', '');
    setclienteId(0);
    setdisabledNome(false);
    setdisabledCPF(false);
    setdisabledEMAIL(false);
    setSexo('');
    setcanalMidia('');
    session.clienteSexo = '';
  }

  const handleCPFChange = e => {
    setClienteExiste(false);
    let cpf = e.target.value;
    if (cpf === "")
      return;
    if (cpf.length < 14)
      return;

    setloadingValidateCPF(true);

    const endPoint = "clientes/clientebycpfvenda/" + cpf + "/" + session.estabelecimentoId;
    UseGetApiSimple(endPoint, 0).then(result => {
      // retorno = 500 é exception especifica para cliente que está na LISTA NEGRA!
      if (result.status === 500) {
        showNotification(result.message, 'danger')
        setloadingValidateCPF(false);
        return false;
      }
      if (result.status !== 200) { //Se clienteId diferente de 0 significa que já encontrou o cliente através da busca por email, E o campo de CPF do cliente estava em branco, por isso permitiu preencher    
        // Se clienteId = 0 significa que ta buscando direto pelo cpf e não encontrou esse cliente com esse cpf, então permite preencher todos os campos pra cadastrar novo cliente
        if (clienteId == 0) {

          setdisabledNome(false);
          setdisabledCPF(false);
          setdisabledEMAIL(false);
          setClienteExiste(false);
        }
        else {
          setClienteExiste(true);
        }
        setloadingValidateCPF(false);
        return false;
      }

      setClienteExiste(true);
      setValue('cpf', result.data.cpf);
      setValue('nome', result.data.nome);
      setValue('email', result.data.email);
      setValue('celular', result.data.celular);

      setdisabledNome(true);
      if (result.data.cpf != "" && result.data.cpf != null) {
        setdisabledCPF(true);
      }
      else {
        setdisabledCPF(false);
      }
      if (result.data.email != "" && result.data.email != null) {
        setdisabledEMAIL(true);
      }
      else {
        setdisabledEMAIL(false);
      }

      if (result.data.sexo !== null) {
        setSexo(result.data.sexo);
        setValue("sexo", result.data.sexo);
        session.clienteSexo = result.data.sexo;
      }
      setValue('atendente', result.data.cpf);

      setCpf(result.data.cpf);
      setclienteId(result.data.clienteId);

      clearError("cpf");
      setloadingValidateCPF(false);
    });
  }

  const handleEmailChange = e => {
    let email = e.target.value;
    if (email === "") {
      return;
    }

    setloadingValidateEmail(true);
    const endPoint = "clientes/clientebyemailvenda/" + email + "/" + session.estabelecimentoId;
    UseGetApiSimple(endPoint, 0).then(result => {
      // retorno = 500 é exception especifica para cliente que está na LISTA NEGRA!
      if (result.status === 500) {
        showNotification(result.message, 'danger')
        setloadingValidateEmail(false);
        return false;
      }
      if (result.status !== 200) {
        //Se clienteId diferente de 0 significa que já encontrou o cliente através da busca por cpf, E o campo de email do cliente estava em branco, por isso permitiu preencher    
        // Se clienteId = 0 significa que ta buscando direto pelo email e não encontrou esse cliente com esse email, então permite preencher todos os campos pra cadastrar novo cliente
        if (clienteId == 0) {
          setloadingValidateEmail(false);

          setdisabledNome(false);
          setdisabledCPF(false);
          return false;
        }
        else {
          setClienteExiste(true);
        }
        setloadingValidateEmail(false);
        return false;

      }

      // Se existe esse cliente no sistema buscando pelo e-mail, verificar se ele possui CPF no seu cadastro. Se sim, exibir todos os dados do seu cadastro
      // e não permitir alterar nem cpf e nem nome, Se existe esse cliente mas não tem CPF no cadastro não bloquear o campo CPF, para que ele possa informar um CPF válido
      setclienteId(result.data.clienteId);
      setClienteExiste(true);
      setdisabledNome(true);
      setValue('nome', result.data.nome);
      setValue('email', result.data.email);
      setValue('celular', result.data.celular);
      if (result.data.sexo !== null) {
        setSexo(result.data.sexo);
        setValue("sexo", result.data.sexo);
        session.clienteSexo = result.data.sexo;
      }

      if (result.data.cpf != "" && result.data.cpf != null) {
        setValue('cpf', result.data.cpf);
        setCpf(result.data.cpf);
        setdisabledCPF(true);
      }
      else {
        setdisabledCPF(false);
      }
      if (result.data.email != "" && result.data.email != null) {
        setdisabledEMAIL(true);
      }
      else {
        setdisabledEMAIL(false);
      }

      setloadingValidateEmail(false);
    });
  }

  const handleSexoChange = event => {
    setSexo(event.target.value);
    setValue("sexo", event.target.value);
    session.clienteSexo = event.target.value;
    if (event.target.value !== "")
      clearError("sexo");
  };

  const handleCanalMidiaChange = event => {
    let value = event
    setcanalMidia(value);
    setValue("canalMidia", value);
    if (value !== "")
      clearError("canalMidia");
  };

  const onSubmit = (dados) => {
    if ((canalMidia === "" || canalMidia === 0))
      return setError("canalMidia", "required")
    else
      clearError("canalMidia")

    let cliente = {
      'clienteId': clienteId,
      'cpf': dados.cpf,
      'nome': dados.nome,
      'email': dados.email,
      'celular': dados.celular,
      'sexo': dados.sexo,
      'atendente': dados.cpf,
      'UsuarioCadastroId': session.id,
      'estabelecimentoClientes': [{
        'estabelecimentoId': session.estabelecimentoId
      }]
    }

    let avaliacao = {
      avaliacaoId: null,
      cliente: cliente,
      canalMidia: canalMidia,
      kg: null,
      altura: null,
      idade: null,
      quadril: null,
      cintura: null,
      peso5anos: null,
      gordura: null,
      sedentarismo: null
    }

    setAvaliacaoCookie(avaliacao);

    if (clienteExiste === true) {
      UsePutApi("clientes/AtualizaClienteAvaliacao", '', cliente).then(result => {
        if (result.status !== 200 && result.status !== 201) {
          setloadingValidateCPF(false);
          showNotification(result.message, 'danger');
          return false;
        }
        else {
          nextButtonClick();
        }
      });
    }
    else {
      UsePostApi("clientes", cliente).then(result => {
        if (result.status !== 200 && result.status !== 201) {
          setloadingValidateCPF(false);
          showNotification(result.message.message, 'danger');
          return false;
        }
        else {
          nextButtonClick();
        }
      });
    }
  }

  useEffect(() => {
    const ReloadedDadosCliente = sessionStorage.getItem('ReloadedDadosCliente');
    if (!ReloadedDadosCliente) {
      window.location.reload(true);
      sessionStorage.setItem('ReloadedDadosCliente', 'true');
    }
    loadingDados();
    LoadingSelectCanalMidia();
    return () => {
      sessionStorage.removeItem('ReloadedDadosCliente');
    };
  } , []);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Snackbar
        place="tr"
        color={colorNotification}
        message={mensagemNotification}
        open={notification}
        closeNotification={() => setNotification(false)}
        close
      />
      <div style={{ maxWidth: '800px', margin: '0 auto' }}>
        <GridContainer>
          <GridItem xs={12} sm={3} md={3}>
            <div className={classes.labelIdent}>
              {t('label.cpf')}
            </div>
          </GridItem>
          <GridItem xs={12} sm={5} md={5}>
            <TextField
              fullWidth
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              onBlur={handleCPFChange}
              defaultValue=""
              name="cpf"
              disabled={disabledCPF}
              inputRef={register({ required: true })}
              error={errors.cpf ? true : false}
              InputProps={{
                inputComponent: MaskCPF,
                endAdornment: (
                  <InputAdornment position="end">
                    {loadingValidateCPF && <LoadingIcon className="rotate" />}
                  </InputAdornment>
                ),
              }}
            />
            <FormHelperText>
              {errors.cpf && <span className="obg">{t('label.required')}</span>}
            </FormHelperText>
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem xs={12} sm={3} md={3}>
            <div className={classes.labelIdent}>
              {t('label.name')}
            </div>
          </GridItem>
          <GridItem xs={12} sm={7} md={7}>
            <TextField
              fullWidth
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              defaultValue=""
              name="nome"
              disabled={disabledNome}
              inputRef={register({ required: true })}
              error={errors.nome ? true : false}
            />
            <FormHelperText>
              {errors.nome && <span className="obg">{t('label.required')}</span>}
            </FormHelperText>
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem xs={12} sm={3} md={3}>
            <div className={classes.labelIdent}>
              {t('label.email')}
            </div>
          </GridItem>
          <GridItem xs={12} sm={7} md={7}>
            <TextField
              fullWidth
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              defaultValue=""
              name="email"
              disabled={disabledEMAIL}
              onBlur={handleEmailChange}
              inputRef={register({ required: true })}
              error={errors.email ? true : false}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {loadingValidateEmail && <LoadingIcon className="rotate" />}
                  </InputAdornment>
                ),
              }}
            />
            <FormHelperText>
              {errors.email && <span className="obg">{t('label.required')}</span>}
            </FormHelperText>
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem xs={12} sm={3} md={3}>
            <div className={classes.labelIdent}>
              Celular
            </div>
          </GridItem>
          <GridItem xs={12} sm={4} md={4}>
            <TextField
              fullWidth
              variant="outlined"
              InputLabelProps={{ shrink: true }}
              defaultValue=""
              name="celular"
              inputRef={register({ required: true })}
              error={errors.celular ? true : false}
              InputProps={{
                inputComponent: MaskCel
              }}
            />
            <FormHelperText>
              {errors.celular && <span className="obg">Obrigatório</span>}
            </FormHelperText>
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem xs={12} sm={3} md={3}>
            <div className={classes.labelIdent}>
              {t('label.gender')}
            </div>
          </GridItem>
          <GridItem xs={12} sm={4} md={4}>
            <TextField
              fullWidth
              error={errors.sexo ? true : false}
              select
              variant="outlined"
              value={sexo}
              onChange={handleSexoChange}
              name="sexo"
              ref={() => register({ name: "sexo" }, { required: true })}
              InputLabelProps={{ shrink: true }}
            >
              <MenuItem value="0">
                {t('label.female')}
              </MenuItem>
              <MenuItem value="1">
                {t('label.male')}
              </MenuItem>
            </TextField>
            <FormHelperText>
              {errors.sexo && <span className="obg">{t('label.required')}</span>}
            </FormHelperText>
          </GridItem>
        </GridContainer>

        <GridContainer>
          <GridItem xs={12} sm={3} md={3}>
            <div className={classes.labelIdent}>
              {t('label.media_channel')}
            </div>
          </GridItem>
          <GridItem xs={12} sm={4} md={4}>
            <Select
              classNamePrefix="select"
              styles={ValidSelect(errors.canalMidia ? true : false)}
              isSearchable={true}
              isLoading={loadingSelectCanalMidia}
              name="canalMidia"
              placeholder={t('label.select') + " ..."}
              options={listSelectCanalMidia}
              value={listSelectCanalMidia.filter(({ canalMidiaId }) => canalMidiaId === canalMidia)}
              getOptionLabel={({ descricao }) => descricao}
              getOptionValue={({ canalMidiaId }) => canalMidiaId}
              onChange={(value) => handleCanalMidiaChange(value.canalMidiaId !== null ? value.canalMidiaId : "")}
            />
            <FormHelperText>
              {errors.canalMidia && <span className="obg">{t('label.required')}</span>}
            </FormHelperText>
          </GridItem>
        </GridContainer>
        <br></br>
      </div>

      <div className={classes_wizard.right}>
        <Button type="submit" className="no-print" color="primary">
          {t('button.next')}
        </Button>
      </div>
      <div className={classes_wizard.left}>
        <Button className="no-print" color="warning" onClick={() => reinicializarClick()}>
          {t('button.restart')}
        </Button>
      </div>

      <br />
      <br />

    </form>
  );
}